// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Loader } from "semantic-ui-react";

// Styles
import styles from "./styles.module.css";

const MessageListHeader = ({ context: { isLoading } }) => {
	if (!isLoading) return null;
	return (
		<div className={styles.container}>
			<Loader active inline="centered" size="large" />
		</div>
	);
};

MessageListHeader.propTypes = {
	context: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default MessageListHeader;
